module.exports = __webpack_public_path__ + "static/media/iphone-mockup.81f86a28.png";